import React, { useEffect, useState } from "react";
import SidebarFilter from "../../../components/SidebarFilter";
import t from "../../../helpers/t";
import { moment } from '../../../../../vendor';

export default props => {
  const { from: startDate, to: endDate} = props;
  const [activeValue,setActiveValue] = useState('current-month');

  useEffect(() => {
    handleChangeDateRange(activeValue);
  }, [activeValue]);
  const handleChangeDateRange = (option, time="") => {
    switch (option) {
      case "current-year": {
        const currentYear = new Date().getFullYear();
        const startDate = new Date(currentYear, 0, 1);
        const endDate = new Date(currentYear, 12, 0);
        time
          ? time === "from"
            ? props.onFilterChange({ from: startDate })
            : props.onFilterChange({ to: endDate })
          : props.onFilterChange({ from: startDate, to: endDate });
        break;
      }
      case "current-month": {
        const currentMonth = new Date().getMonth();
        const currentYear = new Date().getFullYear();
        const startDate = new Date(currentYear, currentMonth, 1);
        const endDate = new Date(currentYear, currentMonth + 1, 0);
        time
          ? time === "from"
            ? props.onFilterChange({ from: startDate })
            : props.onFilterChange({ to: endDate })
          : props.onFilterChange({ from: startDate, to: endDate });
        break;
      }
      case "last-year": {
        const lastYearMoment = moment().subtract(1, 'year');
        const startDate = lastYearMoment.clone().startOf('year').toDate();
        const endDate = lastYearMoment.clone().endOf('year').toDate();
        time
          ? time === "from"
            ? props.onFilterChange({ from: startDate })
            : props.onFilterChange({ to: endDate })
          : props.onFilterChange({ from: startDate, to: endDate });
        break;
      }
      case "last-month": {
        moment()
        const lastMonthMoment = moment().subtract(1, 'month');
        const startDate = lastMonthMoment.clone().startOf('month').toDate();
        const endDate = lastMonthMoment.clone().endOf('month').toDate();
        time
          ? time === "from"
            ? props.onFilterChange({ from: startDate })
            : props.onFilterChange({ to: endDate })
          : props.onFilterChange({ from: startDate, to: endDate });
        break;
      }
      default: {
        const d = new Date();
        props.onFilterChange({ from: d, to: d });
        return;
      }
    }
  };
 
  return (
    <>
      <SidebarFilter
        id="inb-c-left-bar-flist--filter-chart"
        heading={t("timespan", null, "capital")}
        type="datePicker"
        data={[
          {
            name: "date_from",
            className: "noBorders-noBackground",
            dateFormat: "dd.MM.y",
            selected: startDate,
            onChangeHandle: date => {
              if (date) {
                props.onFilterChange({ from: date });
              }else{
                handleChangeDateRange(activeValue, "from");
              }
            },
            placeholder: t("valid_from", null, "capital") + " ...",
          },
          {
            name: "date_to",
            className: "noBorders-noBackground",
            dateFormat: "dd.MM.y",
            selected: endDate,
            onChangeHandle: date => {
              if (date) {
                props.onFilterChange({ to: date });
              }else{
                handleChangeDateRange(activeValue, "to");
              }
            },
            placeholder: " ..." + t("valid_to", null, "capital"),
          },
        ]}
      />
      <SidebarFilter
        id="inb-c-left-bar-flist--filter-chart-quick"
        heading=""
        type="list"
        selected={activeValue}
        data={[
          { name: t("current_year"), value: "current-year" },
          { name: t("current_month"), value: "current-month" },
          { name: t("previous_year"), value: "last-year" },
          { name: t("previous_month"), value: "last-month" },
        ]}
        dataKey="value"
        //onChangeHandle={handleChangeDateRange}
        onChangeHandle={value =>
          setActiveValue(value)
        }
      />
    </>
  );
};
